import { InfiniteScrollList } from "@/Components/Media/InfiniteScroll"
import type { IWebCOOSParsedGalleryService, IWebCOOSAssetSummaryView, IWebCOOSElement } from "@/services/assets/types"
import type { ReactElement, ReactNode } from "react"

const GalleryGrid = ({
    service,
    summary,
    start,
    end,
    ItemContainer = ({ children }: {
        element: IWebCOOSElement,
        children: ReactNode
    }): ReactElement => {
        return (
            <>{children}</>
        )
    }
}: {
    service: IWebCOOSParsedGalleryService,
    summary: IWebCOOSAssetSummaryView,
    start: Date,
    end: Date,
    ItemContainer?: React.FC<{ element: IWebCOOSElement, children: ReactNode }>

}): ReactElement => {

    //const end = makeUTCDate(service?.elements.last_ending ?? service?.elements.last_starting ?? makeUTCDate())
    //const start = makeUTCDate(+end - 24 * 60 * 60 * 1000)





    return (
        <div className='flex flex-col gap-4 h-full'>

            <div className='relative min-h-[40vh]'>{
                service !== undefined
                    ? <InfiniteScrollList
                        start={start}
                        end={end}
                        service={service}
                        asset={summary}
                        ItemContainer={ItemContainer}
                    />
                    : <>Pick one</>
            }</div>
        </div>

    )
}

export default GalleryGrid